<template>
	<div style="margin-top: 1px">
		<Stack monitor-images-loaded :column-min-width="320" :gutter-height="-1">
			<StackItem v-for="i in shuffledNumbers(41)" :key="i" class="img-container">
				<img :src="require(`@/assets/gallery/${i}.jpg`)"/>
			</StackItem>
		</Stack>
	</div>
</template>

<script>
	import { Stack, StackItem } from 'vue-stack-grid';

	export default {
		name: "Gallery",
		components: { Stack, StackItem },
		methods: {
			shuffledNumbers(size) {
				const array = []

				for (let i = 0; i < size; i++) array.push(i + 1)

				for (let i = array.length - 1; i > 0; i--) {
					const j = Math.floor(Math.random() * (i + 1));
					[array[i], array[j]] = [array[j], array[i]];
				}

				return array
			}
		}
	}
</script>

<style scoped>

	.img-container {
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: center;
		overflow: hidden;
		margin: 0;
		object-fit: fill;
	}
	.img-container img {
		display: block;
		margin: 0;
		width: 100%;
		height: auto;
	}
	.img-container figcaption {
		margin: 3px 0;
		text-align: center;
	}
</style>
